import React from "react";
import { Form } from "antd";
import { InputText } from "../../components/FormControls";
import styles from "./styles/UserProfilePage.scss";

interface FormInputTextProps {
  field: string;
  title: React.ReactNode;
  isRequired: boolean;
  validationText?: string;
  validator?: (rule: any, value: any, callback: (message?: string) => void) => void;
  inputTextProps?: Record<string, any>;
  shouldShowValue?: boolean;
  form: any;
  userProfile: any;
}

export const FormInputText: React.FC<FormInputTextProps> = ({
  field,
  title,
  isRequired,
  validationText,
  validator,
  inputTextProps = {},
  shouldShowValue = true,
  form,
  userProfile,
}) => {
  const rules = [];
  let initialValue;

  if (isRequired) {
    rules.push({
      required: isRequired,
      message: validationText
    });
  }

  if (validator) {
    rules.push({ validator });
  }

  if (shouldShowValue && userProfile[field]) {
    initialValue = { [field]: userProfile[field] };
  }

  return (
    <Form.Item className={styles.formItem}>
      {form.getFieldDecorator(field, {
        initialValue,
        rules
      })(
        <InputText
          {...inputTextProps}
          field={field}
          title={title}
          isRequired={isRequired}
        />
      )}
    </Form.Item>
  );
};



// WEBPACK FOOTER //
// ./src/containers/UserProfilePage/FormInputText.tsx